export const isLocal = import.meta.env.MODE === "local-test";
export const env = reactive<Record<string, string>>({});

export function getEnv(key: string) {
  return env[key] || "";
}
